import React from "react";
import { AppShape } from "@eave/shared/types/api";
import { connect } from "react-redux";
import { loadApp } from "underwriter_dashboard/actions";
import WorksheetTable from "web_modules/shared/carbon/Worksheets/WorksheetTable";
import { ENUM, WorksheetName, WS_NAME } from "underwriter_dashboard/shared/WorksheetEditor/wsDefs";
import { notDash } from "underwriter_dashboard/shared/WorksheetEditor/wsValidationHelpers";
import { CarbonInputGenerationParams } from "web_modules/shared/carbon-types";
import { loadSellerCredits, sellerCreditsHeaderData, sellerCreditToRow } from "./shared";
import { WorksheetAs } from "@eave/shared/types/api/worksheets";
import { wsImport } from "underwriter_dashboard/shared/WorksheetEditor/actions";
import { emptyValuesToNull } from "web_modules/shared/carbon/Worksheets/helpers";

interface Props {
  app: AppShape;
  loadApp: Function;
  wsImport: (appId, wsName, wsId) => () => {};
}

class SellerCredits extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { app, loadApp, wsImport } = this.props;

    const modalFields = (worksheets): CarbonInputGenerationParams[] => {
      const fields = [
        {
          name: "method",
          type: "select",
          label: "Method",
          options: ["-", ...ENUM.SELLER_CREDIT_METHODS.map(String)],
          validation: notDash,
        },
        (worksheets?.method === null || worksheets?.method === "PercentageOfPurchasePrice") && {
          name: "percentage_of_purchase_price",
          type: "text",
          label: "Percentage of Purchase Price (% that is > 0 and <= 6)",
          placeholder: "",
          prepareForAPI: emptyValuesToNull,
        },
        {
          name: "manual_override_amount",
          type: "money",
          label: "Manual Override Amount",
          placeholder: "",
          prepareForAPI: emptyValuesToNull,
        },
      ];

      return fields.filter(Boolean);
    };

    return (
      <div>
        <WorksheetTable
          title="Seller Credits"
          app={app}
          loadApp={loadApp}
          headerData={sellerCreditsHeaderData}
          modalFields={modalFields}
          type={WorksheetAs.Object} // Render seller credits WS as a single row
          wsName={WS_NAME.SELLER_CREDITS as WorksheetName}
          wsRecordName={WS_NAME.SELLER_CREDITS as WorksheetName}
          worksheetToRow={sellerCreditToRow}
          worksheetToFormState={loadSellerCredits}
          worksheetImportDataFn={wsImport}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  app: ownProps.app,
  loadApp: appID => {
    loadApp(dispatch, appID);
  },
  wsImport: (wsName, wsId) => dispatch(wsImport(ownProps.app.id, wsName, wsId)),
});

export default connect(null, mapDispatchToProps)(SellerCredits);
